import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from "@tanstack/react-query";
import { axios } from "@via/api/axios.tsx";
import { useNotifications } from "@via/hooks/useNotifications.tsx";
import { ErrorNotification } from "@via/utils/interfaces.tsx";
import { RedeemVoucherCodeRequestBody } from "common";

export const useRedeemVoucherCode = (): UseMutationResult<
  void,
  ErrorNotification,
  RedeemVoucherCodeRequestBody
> => {
  const { setNotification, NOTIFICATION } = useNotifications();
  const queryClient = useQueryClient();

  return useMutation<void, ErrorNotification, RedeemVoucherCodeRequestBody>({
    mutationFn: async (payload: RedeemVoucherCodeRequestBody) => {
      const res = await axios.post("/api/v1/voucher-codes/redeem", payload);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["/api/auth/v1/user"],
        refetchType: "all",
      });
    },
    onError: (error: ErrorNotification) => {
      setNotification({
        id: "redeem-voucher-code-error",
        message: "Invalid Code",
        details:
          error?.response?.data?.message ?? "Code is invalid or has expired.",
        variant: NOTIFICATION.ERROR,
      });
    },
  });
};
